import type { HTMLAttributes } from 'react';
import React from 'react';
import type { ProcessedCmsContentfulImage } from '$cms/contentful.types';
import { Img } from '../../../src/components/atoms/Img';
import styles from './index.module.scss';

export interface HereToHelpProps extends HTMLAttributes<HTMLDivElement> {
  readonly text: string;
  readonly image: ProcessedCmsContentfulImage;
}

export function HereToHelp({ text, image }: HereToHelpProps): JSX.Element {
  return (
    <>
      {text}
      <Img
        className={styles.Img}
        provider="cloudinary"
        src={image.img.original_secure_url}
        alt={image.alt}
        layout="fixed"
        width={image.img.width}
        height={image.img.height}
      />
    </>
  );
}

HereToHelp.displayName = 'HereToHelp';
